/**
 * "Add ANJA to Home Screen" (phones only, hidden once installed).
 * - Android/Chrome/Edge/Samsung: uses the browser's install prompt when it is offered.
 * - iPhone/iPad (Safari has no prompt API) and other browsers: shows short step-by-step instructions.
 */
const isStandalone = () => matchMedia('(display-mode: standalone)').matches || /** @type {any} */ (navigator).standalone === true;
const isPhone = () => matchMedia('(max-width: 989px)').matches && (matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0 || /android|iphone|ipad|ipod|mobile/i.test(navigator.userAgent));
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

/** @type {any} */
let deferred = null;

addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault();
  deferred = event;
});

function sync() {
  const show = isPhone() && !isStandalone();
  document.documentElement.classList.toggle('anja-installed', !show && isStandalone());
}

document.addEventListener('click', async (event) => {
  const target = /** @type {HTMLElement} */ (event.target);
  if (target.closest?.('[data-anja-install-close]')) {
    /** @type {HTMLDialogElement | null} */ (target.closest('dialog'))?.close();
    return;
  }
  if (!target.closest?.('[data-anja-install]')) return;
  try {
    window.Shopify?.analytics?.publish?.('anja_install_click', { ios: isIOS() });
  } catch {}
  if (deferred) {
    deferred.prompt();
    await deferred.userChoice.catch(() => null);
    deferred = null;
    sync();
    return;
  }
  const sheet = /** @type {HTMLDialogElement | null} */ (document.querySelector('[data-anja-install-sheet]'));
  if (!sheet) return;
  sheet.querySelector('[data-ios]')?.toggleAttribute('hidden', !isIOS());
  sheet.querySelector('[data-android]')?.toggleAttribute('hidden', isIOS());
  sheet.showModal();
});

addEventListener('appinstalled', sync);
sync();
document.addEventListener('DOMContentLoaded', sync);
